import { ChangeDetectionStrategy, Component, computed, inject, model, signal } from '@angular/core';
import { MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { NotificationsService } from './notifications.service';
import { ModalHeaderComponent } from '../modal-header/modal-header.component';
import { MessageService } from '../../../Reusables/reusable-pages/messages/message.service';
import {
  INotificationReceiver
} from '../../../Reusables/reusable-pages/messages/messages.model';
import { BtnComponent, LoaderComponent, TrimTextPipe } from 'ets-fe-ng-sdk';
import { UtilityService } from '../../../Services/utility.service';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TranslatePipe } from '../../pipes/translate.pipe';
import { AsyncPipe, DatePipe, NgClass } from '@angular/common';
import { FormsModule } from '@angular/forms';
import ModalComponents from '../modal-components/modal.components';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationHistoryComponent } from './notification-history/notification-history.component';
import { NotificationHandlerService } from './notification-handler.service';

@Component({
  selector: 'notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
  imports: [
    ModalHeaderComponent,
    MatDialogModule,
    BtnComponent,
    MatSlideToggleModule,
    LoaderComponent,
    TranslatePipe,
    AsyncPipe,
    FormsModule,
    TrimTextPipe,
    ModalComponents,
    NgClass,
    DatePipe,
    NotificationHistoryComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationsComponent {
  readonly notificationHandlerService = inject(NotificationHandlerService);
  readonly selectedNotification = signal<INotificationReceiver>(null);
  readonly notifications = computed(() => this.nS.notifications());
  readonly notificationGroups = computed(() => this.nS.notificationGroups());
  readonly loading = computed(() => this.nS.loading() && !this.notifications()?.length);
  readonly loadingCanLoadMore = computed(() => this.nS.loading());
  readonly canLoadMore = computed(() => this.nS.canLoadMore());
  readonly showOnlyUnread = model(true);
  readonly expandedMap = signal<{ [id: string]: boolean }>({});

  constructor(
    public nS: NotificationsService,
    public dialogRef: MatDialogRef<NotificationsComponent>,
    public mS: MessageService,
    public uS: UtilityService,
    public router: Router,
    public route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    if (!this.nS.loadedNotifications())
      try {
        this.loadMore();
      } catch (error) {}
  }

  async loadMore() {
    try {
      await this.nS.loadMore();
    } catch (error) {
      // debugger;
      this.uS.info(error, 0);
    }
  }

  toggleExpanded(id: string) {
    this.expandedMap.update((mp) => ({ ...mp, [id]: !mp[id] }));
  }

  async toggleShowOnlyUnread(showRead: boolean) {
    try {
      await this.nS.toggleShowOnlyUnread(showRead);
    } catch (error) {
      this.uS.info(error, 0);
    }
  }

}
